import { render, staticRenderFns } from "./author_note.vue?vue&type=template&id=124e2339&scoped=true&"
import script from "./author_note.vue?vue&type=script&lang=js&"
export * from "./author_note.vue?vue&type=script&lang=js&"
import style0 from "./author_note.vue?vue&type=style&index=0&id=124e2339&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e2339",
  null
  
)

export default component.exports